<template>
    <div class="notice">
        <!-- <div class="noticeHead">
            <div class="title">通知/公告</div>
            <div class="more" @click="moreData()">更多 +</div>
        </div> -->
        <!-- <div class="selectNoticeType" >
            <div v-for="(item,index) in notificationTypeList" :key="item.value" :style="getStyle(index)" @click="selectItem(index)">
                {{ item.lable }}
            </div>
        </div> -->
        <div class="noticeContent">
            <div class="noticeCarousel">
                <!--轮播图-->
                <el-carousel height="320px" class="top-left-card__carousel">
                    <el-carousel-item v-for="(banner, index) in banners2" :key="index" style="display: table-cell; //主要是这个属性">
                        <img :src="banner.picUrl"  style="width:100%;height:320px;cursor:pointer;" :id="banner.id" @click="clickProps($event)"/>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="noticeList">
                <div style="position: relative;">
                    <el-tabs v-model="activeName" >
                        <el-tab-pane label="协会动态" name="first">
                            <div  v-for="(item, index) in dynamicList"  :key="index" >
                                <div class="notificationBox"  >
                                    <div class="dot"></div>
                                    <div :class="['Title', selectedRow == index ? 'selectRow'  : '']" @click="skipAssociationNews(item, index)">{{item.title}}</div>
                                    <div class="time">
                                        {{item.createDate}}
                                    </div>
                                </div>
                        </div>
                        </el-tab-pane>
                        <el-tab-pane label="通知公告" name="second">
                            <div  v-for="(item, index) in informList"  :key="index">
                                <div class="notificationBox"  >
                                    <div class="dot"></div>
                                    <div :class="['Title', selectedRowTwo == index ? 'selectRow'  : '']" @click="skipNotice(item, index)">{{item.title}}</div>
                                    <div class="time">
                                        {{item.createDate}}
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="行业资讯" name="third">
                            <div  v-for="(item, index) in industryInfoList"  :key="index" >
                                <div class="notificationBox"  >
                                    <div class="dot"> </div>
                                    <div :class="['Title', selectedRowThree == index ? 'selectRow'  : '']" @click="skipIndustryInformation(item, index)">{{item.title}}</div>
                                    <div class="time">
                                        {{item.createDate}}
                                    </div>
                                </div>
                            </div> 
                        </el-tab-pane>
                    </el-tabs>
                    <div class="more" style="position: absolute;right:0;top:10px;"  @click="moreData()">更多 +</div>
                </div>
                <!-- <div style="display: flex;justify-content: space-between;align-items: center;">
                    <div v-for="(item,index) in notificationTypeList" :key="item.value" :style="getStyle(index)" @click="selectItem(index)">
                        {{ item.lable }}
                    </div>
                    <div class="more" @click="moreData()">更多 +</div>
                </div>
               
                <div  v-for="(item, index) in dynamicList"  :key="index" v-if="selectedIndex=='0'">
                    <div class="notificationBox"  >
                        <div class="dot"></div>
                        <div :class="['Title', selectedRow == index ? 'selectRow'  : '']" @click="skipAssociationNews(item, index)">{{item.title}}</div>
                        <div class="time">
                            {{item.createDate}}
                        </div>
                    </div>
                </div>


                <div  v-for="(item, index) in informList"  :key="index" v-if="selectedIndex=='1'">
                    <div class="notificationBox"  >
                        <div class="dot"></div>
                        <div :class="['Title', selectedRowTwo == index ? 'selectRow'  : '']" @click="skipNotice(item, index)">{{item.title}}</div>
                        <div class="time">
                            {{item.createDate}}
                        </div>
                    </div>
                </div>

                <div  v-for="(item, index) in industryInfoList"  :key="index" v-if="selectedIndex=='2'">
                    <div class="notificationBox"  >
                        <div class="dot"> </div>
                        <div :class="['Title', selectedRowThree == index ? 'selectRow'  : '']" @click="skipIndustryInformation(item, index)">{{item.title}}</div>
                        <div class="time">
                            {{item.createDate}}
                        </div>
                    </div>
                </div> -->
            </div>
            
        </div>
    </div>
</template>

<script>
import * as dayjs from 'dayjs';
import { prefixedUrlAsset } from '@/utils/constants';
// import banner1 from '@/assets/img/banner2601.jpg';
export default {
    props: {
        dynamicList: {
            type: Array,
            default: () => {}
        },
        informList: {
            type: Array,
            default: () => {}
        },
        industryInfoList: {
            type: Array,
            default: () => {}
        },
    },
    components: {},
    computed: {
    
    },
    data() {
        return {
            notificationTypeList:[
                {
                    lable:'协会动态'
                },
                {
                    lable:'通知公告'
                },
                {
                    lable:'行业资讯'
                },
            ],
            selectedIndex: 0,
            // dynamicList:[],
            // informList:[],
            banners2:[],
            // industryInfoList:[],
            selectedRow: null,
            selectedRowTwo: null,
            selectedRowThree: null,
            activeName: 'first'
        
        };
    },
 
    created() {

        //获取图片新闻列表
        this.axios.get(`${prefixedUrlAsset}/pub/news/picnews/list?pageNo=0&pageSize=4`).then((response) => {
            if (response.data.data) {
                this.banners2 = response.data.data;
                // 把banner1插入数组第一的位置
                // this.banners2.unshift({
                //     picUrl: banner1,
                // });
            }
        });
        
    },
    mounted() {
        
    },
    methods: {
        moreData(){
            switch (this.selectedIndex) {
                case 0 : 
                    window.open(`/#/list/1/协会动态`);
                    break;
                case 1 : 
                    window.open(`/#/list/2/通知公告`);
                    break;
                case 2 : 
                    window.open(`/#/list/3/行业资讯`);
                    break;
            } 
        },
        selectItem(index) {
            this.selectedIndex = index;
            switch (index) {
                case 0 : 
                    this.selectedRowTwo=null
                    this.selectedRowThree=null
                    break;
                case 1 : 
                    this.selectedRow=null
                    this.selectedRowThree=null
                    break;
                case 2 : 
                    this.selectedRow=null
                    this.selectedRowTwo=null
                    break;
            } 
        },
        getStyle(index) {
            if (this.selectedIndex === index) {
                return {
                    color: '#00A287' ,
                    background:  '#CCECE7 ',
                    borderRadius: '20px 20px 20px 20px',
                    // margin:'0 16px',
                    fontWeight: 'bold',
                    width:'90px',
                    height:'40px',
                    display:'flex',
                    justifyContent:'center',
                    alignItems: 'center',
                    cursor: 'pointer'

                };
            } 
            else {
                return {
                    color: '#000000',
                    fontSize: '16px',
                    margin:'0 24px',
                    fontWeight: 'bold',
                    width:'112px',
                    height:'40px',
                    display:'flex',
                    justifyContent:'center',
                    alignItems: 'center',
                    cursor: 'pointer'
                    

                };
            }
        },
        clickProps(e) {
            if(e.target.id){
                window.open(`/#/detail/`+ e.target.id);
            }
            
        }, 
        //跳转协会动态
        skipAssociationNews(item, index){
            this.selectedRow=index
            window.open(`/#/detail/`+item.id);
        },
        //跳转通知公告
        skipNotice(item, index){
            this.selectedRowTwo=index
            window.open(`/#/detail/`+item.id);
        },
        //跳转行业资讯
        skipIndustryInformation(item, index){
            this.selectedRowThree=index
            window.open(`/#/detail/`+item.id);
        },
    },
};
</script>

<style lang="less">
    .notice{
        padding: 0px 10% 10px 10% ;
        .noticeHead{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .title{
                font-weight: bold;
                font-size: 24px;
                color: #000000;
                font-family: Microsoft YaHei, Microsoft YaHei;
            }
            .more{
                font-size: 14px;
                color: #9AA6B5;
                cursor: pointer;
                &:hover {
                    color: #00A287;
                    font-weight: bold;
                }
            }
        }
        .selectNoticeType{
            display: flex; 
            justify-content: center;
        }
        .noticeContent{
            display: flex;
            margin-top: 10px;
            .noticeCarousel{
                width: 50%;
                margin-right: 20px;
            }
            .noticeList{
                width: 50%;
                background: #fff;
                padding: 13px;
                .notificationBox{
                    display: flex;
                    align-items: center;
                    justify-content:space-between; 
                    padding: 5px 0; 
                    .dot{
                        width: 8px;
                        height: 8px;
                        background: #0BA58C;
                        border-radius: 50%;
                    }      
                    .Title{
                        margin-left: 16px;
                        flex: 1;
                        display: -webkit-box;
                        word-break: break-all;             
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                        font-size: 14px;
                        color: #000000;
                        cursor: pointer;
                        &:hover {
                            color: #00A287;
                        }
                    }
                    .time{
                        width: 100px;
                        margin-left: 10px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #9AA6B5;
                        text-align: right;
                    }
                    .selectRow{
                        color: #00A287
                    }

                }
                .more{
                    font-size: 14px;
                    color: #9AA6B5;
                    cursor: pointer;
                    width: 150px;
                    text-align: right;
                    &:hover {
                        color: #00A287;
                        font-weight: bold;
                    }
                }
                .el-tabs__active-bar {
                    background-color: #00A287;
                    height: 4px;
                }
                .el-tabs__item.is-active {
                    color: #00A287;
                    font-size: 16px;
                }
                .el-tabs__item:hover {
                    color: #00A287;
                    cursor: pointer;
                }
                .el-tabs__item {
                    font-size: 16px;
                }
            }
        }
    }

    
    </style>


<style lang="less">

</style>